import { CustomBot, AiBot, AiInstruction } from 'services/customBots/types'
import actions from './actions'

/** Mirrors the API's `meta.pagination`, but is reset to `{}` on empty/error. */
export interface LoosePagination {
  current_page?: number
  total?: number
  per_page?: number
  count?: number
  total_pages?: number
}

export interface CustomBotsState {
  // Custom Bots tab
  customBotsList: CustomBot[]
  customBotsActive: CustomBot | null
  customBotsTotal: number
  customBotsPagination: LoosePagination
  areCustomBotsLoading: boolean
  /** The last list load failed — the page uses this to allow a retry. */
  customBotsLoadFailed: boolean

  // AI Bots (Legacy) tab
  aiBotsList: AiBot[]
  aiBotsActive: AiBot | null
  aiBotsTotal: number
  aiBotsPagination: LoosePagination
  areAiBotsLoading: boolean
  aiBotsLoadFailed: boolean

  // AI Instructions (Legacy) tab
  aiInstructionsList: AiInstruction[]
  aiInstructionsActive: AiInstruction | null
  aiInstructionsTotal: number
  aiInstructionsPagination: LoosePagination
  areAiInstructionsLoading: boolean
  aiInstructionsLoadFailed: boolean

  /** Every instruction, for the AI Bot form's dropdown — never paginated. */
  aiInstructionOptions: AiInstruction[]
}

const initialState: CustomBotsState = {
  customBotsList: [],
  customBotsActive: null,
  customBotsTotal: 0,
  customBotsPagination: {},
  areCustomBotsLoading: false,
  customBotsLoadFailed: false,

  aiBotsList: [],
  aiBotsActive: null,
  aiBotsTotal: 0,
  aiBotsPagination: {},
  areAiBotsLoading: false,
  aiBotsLoadFailed: false,

  aiInstructionsList: [],
  aiInstructionsActive: null,
  aiInstructionsTotal: 0,
  aiInstructionsPagination: {},
  areAiInstructionsLoading: false,
  aiInstructionsLoadFailed: false,

  aiInstructionOptions: [],
}

interface CustomBotsAction {
  type: string
  payload?: Partial<CustomBotsState>
}

export default function customBotsReducer(
  state: CustomBotsState = initialState,
  action: CustomBotsAction = { type: '' },
): CustomBotsState {
  switch (action.type) {
    case actions.SET_STATE:
      return { ...state, ...action.payload }
    default:
      return state
  }
}
